var _Rect, _G, _Defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Rect, G, Path, Defs, ClipPath } from "react-native-svg";

function SvgAppleHealthWatchTile(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 69,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Rect || (_Rect = /*#__PURE__*/React.createElement(Rect, {
    x: 0.499,
    y: 0.499,
    width: 68.002,
    height: 22.364,
    rx: 2.701,
    stroke: "#CACACA",
    strokeWidth: 0.998
  })), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#apple-health-watch-tile_svg__clip0_3815_12442)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M27.055 14.599h-.024l-1.453-5.937h-1.71l-1.447 5.937h-.023l-1.346-5.937h-1.8l2.264 8.312h1.697l1.495-5.682h.03l1.495 5.682h1.71L30.2 8.662H28.4l-1.346 5.937zm21.483-6.071c-2.144 0-3.425 1.418-3.425 3.8v1.005c0 2.405 1.275 3.781 3.419 3.781 2.15 0 3.222-1.34 3.222-2.838v-.152H50.14c0 .859-.417 1.529-1.578 1.529-1.168 0-1.74-.737-1.74-2.32v-1.005c0-1.565.578-2.35 1.728-2.35 1.078 0 1.59.73 1.59 1.552h1.614v-.085c0-1.62-1.203-2.917-3.216-2.917zm-15.616.134L30.3 16.974h1.686l.588-2.095h2.572l.58 2.095h1.804l-2.614-8.312h-1.995zm.013 4.938l.928-3.3h.017l.913 3.3h-1.858zm25.62-4.938v3.337h-3.323V8.662h-1.685v8.312h1.685V13.43h3.324v3.544h1.691V8.662h-1.691zm-21.053 1.437h2.418v6.875h1.68V10.1h2.423V8.662h-6.521v1.437zm-21.41 1.707c-.012-1.434 1.146-2.124 1.199-2.157-.658-.99-1.674-1.1-2.032-1.127-.913-.069-1.687.522-2.12.522-.438 0-1.114-.507-1.831-.494-.941.015-1.809.56-2.294 1.422-.978 1.736-.25 4.306.703 5.714.465.689 1.02 1.464 1.75 1.435.703-.028.969-.465 1.818-.465.848 0 1.088.465 1.83.45.756-.013 1.236-.7 1.698-1.393.535-.798.755-1.571.768-1.613-.017-.006-1.474-.577-1.488-2.294zm-1.396-4.214c.388-.479.649-1.147.577-1.81-.558.023-1.233.38-1.634.859-.358.424-.673 1.104-.588 1.754.623.05 1.257-.323 1.645-.803z",
    fill: "#CACACA"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "apple-health-watch-tile_svg__clip0_3815_12442"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    transform: "translate(8.55 5.68)",
    d: "M0 0h51.901v11.443H0z"
  })))));
}

export default SvgAppleHealthWatchTile;